import thumbnailReviewer from "./thumbnailReviewer.json";

export default {
  thumbnailReviewer,
  // ... other namespaces
};
